export default {
  chufashiji: lang.templateByUuid("UID:P_UDHWN_17DD50DE050001A8","触发时机") /* "触发时机" */,
  submiting: lang.templateByUuid("UID:P_UDHWN_17DD50DE050001A9","提交时") /* "提交时" */,
  oking: lang.templateByUuid("UID:P_UDHWN_17DD50DE050001AA","确认时") /* "确认时" */,
  submiting1: lang.templateByUuid("UID:P_UDHWN_17DD50DE050001AB","按该客户所有仓库总量设置") /* "按该客户所有仓库总量设置" */,
  submiting2: lang.templateByUuid("UID:P_UDHWN_17DD50DE050001AC","按当前仓库库存量处理") /* "按当前仓库库存量处理" */,
  oking1: lang.templateByUuid("UID:P_UDHWN_17DD50DE050001AC","按当前仓库库存量处理") /* "按当前仓库库存量处理" */
};
